import type { ReactNode } from 'react'
import { SucheKnopf } from '../common/Suche'
import s from './Topbar.module.scss'

interface Props {
  title: string
  subtitle?: string
  actions?: ReactNode
  onOpenNav: () => void
  /** Öffnet die Suche — mit Angabe erscheint der Suchknopf. */
  onSearch?: () => void
  /** Wer angemeldet ist — als Kürzel rechts. */
  user?: string
}

const heute = new Intl.DateTimeFormat('de-DE', {
  weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric',
})

/** „ben" → „BE", „ben.asmussen" → „BA". */
export function initialen(user: string): string {
  const teile = user.split(/[^a-zA-ZäöüÄÖÜß]+/).filter(Boolean)
  const kuerzel = teile.length >= 2
    ? teile[0][0] + teile[1][0]
    : (teile[0] ?? user).slice(0, 2)
  return kuerzel.toUpperCase()
}

/**
 * Die Kopfzeile: Schalter für die Navigation, Titel, rechts die Aktionen
 * der Seite, die Suche, das Datum und wer angemeldet ist.
 */
export function Topbar({ title, subtitle, actions, onOpenNav, onSearch, user }: Props) {
  return (
    <header className={s.head}>
      <button type="button" className={s.burger} onClick={onOpenNav}
              aria-label="Menü öffnen">
        <span /><span /><span />
      </button>

      <div className={s.title}>
        <h1>{title}</h1>
        {subtitle && <span className={s.subtitle}>{subtitle}</span>}
      </div>

      {actions && <div className={s.actions}>{actions}</div>}
      {onSearch && <SucheKnopf onOpen={onSearch} />}
      {user && (
        <div className={s.wer}>
          <span className={s.datum}>{heute.format(new Date()).replace('.,', ',')}</span>
          <span className={s.trenner} aria-hidden="true" />
          <span className={s.avatar} title={user} aria-label={`Angemeldet als ${user}`}>
            {initialen(user)}
          </span>
        </div>
      )}
    </header>
  )
}
